 define('SageDotCom/PatternAnimations/numbersCountUp',[
   "jquery",
   "ScrollMagic",
   "TweenMax",
   "AnimationPlugin"
 ], function(
   $,
   ScrollMagic,
   TweenMax,
   AnimationPlugin
 ) {
   function numbersCountUp() {}

   numbersCountUp.prototype.initialize = function() {

     //Animated numbers Count-Up
     if ($(".number-count-up").length) {

       // inserts classes for all elements inside the component that contains a number
       $(".number-count-up").find('*').each(function() {
         var num = $(this).text();
         if ($.isNumeric(num.charAt(0)) || $.isNumeric(num.charAt(num.length - 1))) {
           $(this).addClass('number');
         } else {
           $(this).addClass('no-number');
         }
       });

       // loops through all elements that contain a number
       $(".number-count-up .number").each(function() {
         var text = $(this).text();

         // stores number and NaN portion of the element that contains a number
         var textNumber = text.match(/[0-9 ]+/).map(function(s) {
           return s.trim().replace(/\s/g, '');
         });
         var textNan = text.match(/[€&!£@#$%^&*()_+}"|"]+/);

         // adds data-value if there is a special character as prefix or suffix
         if (textNan == text[0]) {
           $(this).attr('data-value-prefix', textNan);
         } else {
           $(this).attr('data-value-suffix', textNan);
         };

         // adds the number portion of the string as data-value
         $(this).attr('data-value', textNumber);
         $(this).text(0);
       });

       // sets the animation trigger on the center of the viewport
       var controller = new ScrollMagic.Controller({
         globalSceneOptions: {
           triggerHook: 'onCenter'
         }
       });

       // animates the number and adds suffix or prefix from the data-value if any
       function animated(element) {
         var prefix = "";
         var suffix = "";

         prefix = element.attr('data-value-prefix');
         suffix = element.attr('data-value-suffix');

         element.prop('Counter', 0).animate({
           Counter: element.attr('data-value')
         }, {
           duration: 1300,
           easing: 'swing',
           step: function(now) {
             element.text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
             //
             element.append(suffix);
             element.prepend(prefix);
           }
         });
       }

       // adds animation to the timeline
       $(".number-count-up").each(function() {
         var tl = new TimelineMax();
         var number = $(this).find(".number");

         tl.add(function() {
           animated(number)
         })

         var scene = new ScrollMagic.Scene({
             triggerElement: this,
             triggerHook: 0.7
           })
           .setTween(tl)
           .addTo(controller);
       });
     }

   };

   return new numbersCountUp();
 });

